<template>
  <div
    class="retailer-search-input-fi"
    :class="{
      'retailer-search-input-fi--focused': isFocused,
      'retailer-search-input-fi--active': isActive,
      'retailer-search-input-fi--error': userLocationError,
    }"
  >
    <div class="retailer-search-input-fi__field">
      <label-fi
        class="retailer-search-input-fi__label"
        :label="$dict.get('dealer-Locator.Place-entry')"
      />
      <input
        ref="input"
        :value="value"
        class="retailer-search-input-fi__input"
        type="text"
        data-test="retailer-search-input"
        @keyup.enter="onKeyupEnter"
        @blur="onBlur"
        @focus="onFocusInput"
        @input.stop="onInput"
      />
    </div>
    <div class="retailer-search-input-fi__icons">
      <div
        class="retailer-search-input-fi__icon"
        @click.stop="searchClicked"
      >
        <icon-fi icon="search" />
      </div>
      <div
        v-if="value && value !== ''"
        class="retailer-search-input-fi__icon"
        @click="clearInput"
      >
        <icon-fi icon="close" />
      </div>
      <div
        v-else
        class="retailer-search-input-fi__icon"
        @click.stop="userLocationClicked"
      >
        <loading-indicator-wrapper
          :loading="userLocationLoading"
          variant="spinnerLocal"
          spinoff="in-relative-centered"
        >
          <icon-fi icon="my-location" />
        </loading-indicator-wrapper>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconFi, LabelFi, LoadingIndicatorWrapper } from 'atoms';
import { ref, watch } from 'vue';

defineOptions({ name: 'RetailerSearchInputFi' });

const props = withDefaults(
  defineProps<{
    value?: string;
    userLocationLoading?: boolean;
    userLocationError?: boolean;
  }>(),
  {
    value: '',
    userLocationLoading: false,
    userLocationError: false,
  },
);

const emit = defineEmits<{
  (e: 'clear'): void;
  (e: 'input', value: string | null): void;
  (e: 'keyup-enter', value: string): void;
  (e: 'search', value: string): void;
  (e: 'user-location'): void;
}>();

const isFocused = ref(false);
const isActive = ref(false);

watch(
  () => props.value,
  (newValue) => {
    isActive.value = newValue !== '';
  },
);

function onFocusInput() {
  isFocused.value = true;
}

function onKeyupEnter() {
  emit('keyup-enter', props.value);
}

function onInput(event: Event | null) {
  emit('input', event ? (event.target as HTMLInputElement).value : null);
}

function clearInput() {
  onInput(null);
  emit('clear');
}

function searchClicked() {
  emit('search', props.value);
}

function onBlur() {
  isFocused.value = false;
}

function userLocationClicked() {
  emit('user-location');
}
</script>

<style src="./retailer-search-input-fi" />
